import { RMModal } from 'components/modal';
import React, { useState, useEffect } from 'react';
import {
  AutoUpdateJsonFormat,
  getAutoUpgradeJsonFromUrl,
  getAppVersion,
} from './AutoUpdate.BL';
import { Spinner } from 'react-bootstrap';
import { getCookie, setCookie } from 'utils/Global';
import AutoUpdateDialog from './AutoUpdateDialog';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { setShowUpgradeFallbackDialog } from 'redux/reducers/commonReducer';
import { ResponseDTO, ResponseType } from 'business/models/Models';

type IAutoUpdate = {
  showFallback?: boolean;
};

function AutoUpdate({ showFallback }: IAutoUpdate) {
  const [checkingForUpgrade, isCheckingForUpgrade] = useState(true);
  const dispatch = useRMDispatch();
  const checkForUpgrade = useRMSelector((state) => state?.common.checkForUpgrade);
  const showNoUpgradeDlg = useRMSelector(
    (state) => state?.common.showUpgradeFallbackDialog,
  );
  const [showUpgradeDlg, setShowUpgradeDlg] = useState(false);
  const [upgradeParams, setUpgradeParams] = useState<AutoUpdateJsonFormat>();

  useEffect(() => {
    async function getJson() {
      const upgradeNotified = getCookie('upgradeNotified');
      if (!showNoUpgradeDlg && upgradeNotified === 'true') {
        return;
      }

      isCheckingForUpgrade(true);
      const upgradeObj: ResponseDTO = await getAutoUpgradeJsonFromUrl();
      if (upgradeObj.responseType == ResponseType.Success) {
        const appVersion = await getAppVersion();
        const convertedJson: AutoUpdateJsonFormat = JSON.parse(upgradeObj.message);
        setUpgradeParams(convertedJson);

        const comparison = convertedJson.version.localeCompare(appVersion, undefined, {
          numeric: true,
          sensitivity: 'base',
        });

        setShowUpgradeDlg(comparison > 0);
        setCookie('upgradeNotified', comparison > 0 ? 'true' : 'false', {
          sameSite: 'Lax',
        });
      }
      isCheckingForUpgrade(false);
    }

    getJson();
  }, [checkForUpgrade]);

  const noUpdateAvailableComponent = () => {
    return <div id='autoupdate-noupdateavailablecomponent-text-feedback'>Your Rock Maker version is up to date</div>;
  };

  if (checkingForUpgrade && showNoUpgradeDlg) {
    return (
      <RMModal
        id='autoupdate-chechkingupgrade'
        heading={'Checking for new version...'}
        body={
          <div id='autoupdate-chechkingupgrade-modal' style={{ display: 'flex', justifyContent: 'center', height: '70px' }}>
            <Spinner id='autoupdate-chechkingupgrade-animation' animation={'border'} />
          </div>
        }
        showModal={true}
        setShowModal={() => {
          dispatch(setShowUpgradeFallbackDialog(false));
        }}
        showButtons={false}
      ></RMModal>
    );
  }

  return (
    <>
      {showUpgradeDlg ? (
        <AutoUpdateDialog params={upgradeParams} />
      ) : (
        showNoUpgradeDlg && (
          <RMModal
            id='autoupdate-showupgrade-dlg-no-update'
            body={noUpdateAvailableComponent()}
            heading={'Rock Maker Update'}
            isOkOnly={true}
            okButtonText="Close"
            onOk={() => dispatch(setShowUpgradeFallbackDialog(false))}
            showModal={showNoUpgradeDlg}
            setShowModal={() => {
              dispatch(setShowUpgradeFallbackDialog(false));
            }}
          />
        )
      )}
    </>
  );
}

export default AutoUpdate;
